import { throttle } from 'throttle-debounce';

export default class AdState {
  constructor() {
    this.priorities = {
      'squeeze_frame': 4,
      'superimpose': 3,
      'ticker_tape': 2,
      'pause': 1,
      'overlay': 0,
    }
  }

  tryShowAd(ad, options = {targetings: []}) {
    if (this.shouldUpdateCurrentAd(ad)) {
      this.cancelAnyScheduledShow()
      this.updateCurrentAd(ad, options);
    }
  }

  tryHideAd(ad) {
    ad.hide(false);

    this.tryReset(ad);
  }

  tryReset(ad) {
    if (this.currentAd && this.currentAd.name == ad.name) {
      this.cancelAnyScheduledShow();
      this.currentAd = undefined;
    }
  }

  updateCurrentAd(newAd, options) {
    if(this.currentAd) {
      this.currentAd.hide(false);
    }

    this.scheduledShow = setTimeout(() => {
      newAd.show(options);
    }, this.showDelay);

    this.currentAd = newAd
  }

  get showDelay() {
    return 1500
  }

  shouldUpdateCurrentAd(newAd) {
    if(!newAd.isReady()) {
      return false
    }

    if (!this.currentAd) {
      return true
    }

    return (this.currentAd.name != newAd.name) && 
           (this.priorities[newAd.name] >= this.priorities[this.currentAd.name])
  }

  cancelAnyScheduledShow() {
    if (this.scheduledShow) {
      clearTimeout(this.scheduledShow)
    }
  }
}